import { Box, Button, Grid, Input, Textarea, border } from "@chakra-ui/react";
import React, { useRef } from "react";
import {AiFillLinkedin} from 'react-icons/ai';
import {AiFillTwitterSquare} from 'react-icons/ai';
import {AiFillGithub} from 'react-icons/ai'
import emailjs from '@emailjs/browser';
import("./Contact.css");

export default function Contact() {


  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_gajagnj', 'template_i553n97', form.current, '8QHorspB_hS8iDka0')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };


  return (
    <>
      <Grid id="contact" className="connect" mb={"20px"}
         gridTemplateColumns={{base:"100%" , md:"100%" , lg: "50% 50%"}}
         margin={{base:"auto" , md : "auto"}}
        
         
      >
        <Box   className="container">
          <Box className="Icontainer" >
          <h1 className="con-head">Contact Me</h1>
          <p>
            Drop me a mail at <strong> <a href="mailto:sajay9885@gmail.com" className="mail-id" id="contact-email" >sajay9885@gmail.com</a></strong>
          </p>
          <p  id="contact-phone" >Phone:+91-7509209204</p>
          <div className="links">
            <a
             id="contact-github"
              href="https://github.com/Sajay0623"
              target="_blank"
              rel="noreferrer"
            >

              <AiFillGithub className="fontlink"/>
            </a>
            <a
            id="contact-linkedin"
              href="https://www.linkedin.com/in/ajay-s-611b8623a/"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillLinkedin className="fontlink"/>

            </a>
            <a
              href="https://twitter.com/Sajay9885"
              target="_blank"
              rel="noreferrer"
            >
              {/* <i class="fab fa-twitter"></i> */}
              <AiFillTwitterSquare className="fontlink"/>
            </a>
          </div>

          <h4 className="copyright-text">You can clone my website | Made by Ajay</h4>
          </Box>
         
        </Box>
        <Box  className="container EM"    w={"30rem"} >
      <Box id = "EM" >
      <form ref={form} onSubmit={sendEmail}>
      <label>Name</label>
      <Input type="text" name="user_name" />
      <label>Email</label>
      <Input type="email" name="user_email" />
      <label>Message</label>
      <Textarea name="message" />
      <Button mt={5} w = {"150px"} color={"white"} colorScheme="black"  variant='outline' type="submit" value="Send"  >Submit</Button>
    </form>
      </Box>
        </Box>
      </Grid>

    </>
  );
}

 